import { createSlice } from '@reduxjs/toolkit';

export interface AssetFuelConsumption {
  device: string;
  [eventKey: string]: number | string;
}

export interface PlanningAidState {
  data: AssetFuelConsumption[];
  isLoading: boolean;
}

const initialState: PlanningAidState = {
  data: [],
  isLoading: false,
};

export const planningAidSlice = createSlice({
  name: 'planningAid',
  initialState,
  reducers: {
    setPlanningAidFuelAssets(state, { payload }) {
      state.data = payload;
    },
    setIsLoading(state, { payload }) {
      state.isLoading = payload;
    },
  },
});

export const { setPlanningAidFuelAssets, setIsLoading } =
  planningAidSlice.actions;
export default planningAidSlice.reducer;
